var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2873_701617)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9987 31.334C22.3187 31.334 19.332 34.3073 19.332 38.0007C19.332 41.694 22.3187 44.6673 25.9987 44.6673C29.6787 44.6673 32.6654 41.6807 32.6654 38.0007C32.6654 34.3207 29.692 31.334 25.9987 31.334ZM23.2787 35.2807H25.9987C26.5054 35.2807 26.9054 35.694 26.9054 36.1873C26.9054 36.6806 26.5054 37.094 25.9987 37.094H23.2787C22.772 37.094 22.372 36.6806 22.372 36.1873C22.372 35.694 22.772 35.2807 23.2787 35.2807ZM28.7187 40.7207H23.2787C22.772 40.7207 22.372 40.3073 22.372 39.814C22.372 39.3207 22.7854 38.9073 23.2787 38.9073H28.732C29.2387 38.9073 29.6387 39.3207 29.6387 39.814C29.6387 40.3073 29.2254 40.7207 28.7187 40.7207Z",
    fill: "#037CCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.668 18H27.3346C23.3346 18 20.668 20 20.668 24.6667V28.8533C20.668 29.8267 21.668 30.44 22.5613 30.0533C24.028 29.4133 25.6946 29.1733 27.4413 29.4533C30.9346 30.0267 33.788 32.7867 34.4946 36.2533C34.6946 37.2667 34.7213 38.2533 34.588 39.2C34.4813 39.9867 35.1213 40.68 35.908 40.68H40.668C44.668 40.68 47.3346 38.68 47.3346 34.0133V24.6667C47.3346 20 44.668 18 40.668 18ZM41.2946 25.4533L37.1213 28.7867C36.2413 29.4933 35.1213 29.84 34.0013 29.84C32.8813 29.84 31.748 29.4933 30.8813 28.7867L26.708 25.4533C26.2813 25.1067 26.2146 24.4667 26.548 24.04C26.8946 23.6133 27.5213 23.5333 27.948 23.88L32.1213 27.2133C33.1346 28.0267 34.8546 28.0267 35.868 27.2133L40.0413 23.88C40.468 23.5333 41.108 23.6 41.4413 24.04C41.788 24.4667 41.7213 25.1067 41.2946 25.4533Z",
    fill: "#037CCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2873_701617",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_701617"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_701617",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaill);
export default __webpack_public_path__ + "static/media/maill.3ed8a6f4e8b69e147788dea26428324e.svg";
export { ForwardRef as ReactComponent };